(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dwaal-vosotras"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dwaal-vosotras')) {
  customElements.define('dwaal-vosotras', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const track = this.querySelector('.dw-vos__track');
      const controls = this.querySelector('.dw-vos__controls');
      const buttons = [...controls.querySelectorAll('button')];
      const update = () => {
        const max = track.scrollWidth - track.clientWidth;
        controls.hidden = max < 2;
        buttons[0].disabled = track.scrollLeft < 2;
        buttons[1].disabled = track.scrollLeft >= max - 2;
      };
      buttons.forEach(button => button.addEventListener('click', () => {
        track.scrollBy({left: Number(button.dataset.direction) * (track.querySelector('a').getBoundingClientRect().width + 12), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }));
      track.addEventListener('scroll', update, {passive:true});
      this.observer = new ResizeObserver(update);
      this.observer.observe(track);
      update();
    }
    disconnectedCallback() { this.observer?.disconnect(); this.ready = false; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
